import type { DriveManagementCopy } from '@/i18n/drives-management-copy-types';

export const ptBrDriveManagementCopy = {
  description:
    'Arquivos compartilhados para equipes, projetos e colaboradores.',
  createDrive: 'Criar unidade',
  createDriveTitle: 'Criar uma unidade compartilhada',
  driveName: 'Nome da unidade',
  driveNameHint:
    'Os nomes das unidades são exclusivos e se tornam o caminho legível da pasta.',
  driveNameTaken: 'Já existe uma unidade chamada “{name}”.',
  driveNameReserved: '“{name}” é reservado. Escolha outro nome.',
  driveNameInvalid: 'Use letras ou números no nome da unidade.',
  driveNameSuggestions: 'Disponíveis:',
  driveDescription: 'Descrição (opcional)',
  governance: 'Unidade para',
  curatorOptIn: 'Tornar-me gerente da biblioteca',
  workspace: 'Espaço de trabalho',
  teamGoverned: 'Equipe',
  projectGoverned: 'Projeto',
  selectTeam: 'Selecione uma equipe',
  selectProject: 'Selecione um projeto',
  projectVisibility: 'Visibilidade do projeto',
  assignedMembers: 'Membros atribuídos',
  workspaceVisible: 'Visível no espaço de trabalho',
  customAudience: 'Público personalizado',
  primaryProjectDrive: 'Tornar esta a unidade principal do projeto',
  create: 'Criar',
  cancel: 'Cancelar',
  loading: 'Carregando unidades…',
  emptyTitle: 'Nenhuma unidade disponível',
  emptyDescription:
    'Crie uma unidade compartilhada ou peça acesso a um gerente.',
  openDrive: 'Abrir unidade',
  settings: 'Configurações da unidade',
  members: 'Membros',
  links: 'Vínculos',
  permissions: 'Permissões',
  workflow: 'Fluxo de trabalho',
  activity: 'Atividade',
  storage: 'Armazenamento',
  role: 'Função',
  status: 'Situação',
  usage: 'Armazenamento usado',
  restrictedFolders: 'Pastas restritas',
  guestManagement: 'Gerenciamento de convidados',
  createFailed: 'Não foi possível criar a unidade.',
  addMember: 'Adicionar membro',
  removeMember: 'Remover',
  selectMember: 'Selecione um membro do espaço de trabalho',
  noDirectMembers: 'Ainda não há membros diretos.',
  unknownMember: 'Membro desconhecido',
  loadMoreMembers: 'Carregar mais membros',
  memberAdded: 'Membro adicionado.',
  memberRemoved: 'Membro removido.',
  membersFailed: 'Não foi possível atualizar os membros da unidade.',
  managerOnly: 'Somente gerentes da unidade podem gerenciar membros.',
  linkType: 'Tipo de vínculo',
  selectLinkTarget: 'Selecione uma equipe ou projeto',
  addLink: 'Adicionar vínculo',
  removeLink: 'Remover',
  noLinks: 'Esta unidade não tem vínculos com equipes ou projetos.',
  unknownLink: 'Contexto indisponível',
  linkAdded: 'Vínculo da unidade adicionado.',
  linkRemoved: 'Vínculo da unidade removido.',
  linksFailed: 'Não foi possível atualizar os vínculos da unidade.',
  viewerDownloads: 'Permitir que visualizadores baixem arquivos',
  publicLinksWorkspacePolicy:
    'Os links públicos continuam sujeitos à política do proprietário do espaço de trabalho.',
  selectFolder: 'Selecione uma pasta',
  restrict: 'Restringir',
  removeRestriction: 'Remover limite',
  boundaryCreated: 'Limite de pasta restrita criado.',
  boundaryRemoved: 'Limite de pasta restrita removido.',
  createWorkflow: 'Criar fluxo de trabalho padrão',
  workflowCreated: 'Fluxo de trabalho padrão criado.',
  noWorkflows: 'Nenhum fluxo de trabalho está configurado para esta unidade.',
  noActivity: 'Ainda não há atividade nesta unidade.',
  activityAccess: 'Acesso alterado',
  activityContent: 'Atividade de conteúdo',
  activityWorkflow: 'Atividade do fluxo de trabalho',
  activityPublish: 'Atividade de publicação',
  activityGovernance: 'Configurações da unidade atualizadas',
  activityRecovery: 'Atividade de recuperação',
  activitySecurity: 'Atividade de segurança',
  activityAutomation: 'Atividade do agente',
  activityDrive: 'Unidade atualizada',
  policyUpdated: 'Política da unidade atualizada.',
  settingsFailed: 'Não foi possível atualizar as configurações da unidade.',
  guestEmail: 'E-mail da conta do convidado',
  addGuest: 'Adicionar convidado',
  guestAdded: 'Convidado adicionado como comentarista.',
  guestFailed:
    'Não foi possível adicionar este convidado. Ele precisa ter uma identidade IMAI.',
  guestExpiry:
    'O acesso do convidado expira após 90 dias por padrão e é limitado à função de colaborador.',
  recovery: 'Recuperação',
  contentAccessRequired: 'Acesso ao conteúdo necessário',
  recoveryDescription:
    'Atribua um gerente substituto sem abrir nem visualizar o conteúdo da unidade.',
  replacementManager: 'Selecione um gerente substituto',
  assignManager: 'Atribuir gerente',
  recoveryAssigned: 'Gerente substituto atribuído.',
  recoveryFailed: 'Não foi possível atribuir o gerente substituto.',
  publishToLibrary: 'Publicar na unidade do espaço de trabalho',
  publish: 'Publicar',
  publishStarted: 'Cópia para a biblioteca gerenciada iniciada.',
  publishFailed: 'Não foi possível publicar este arquivo.',
  noPublishableFiles: 'Esta unidade não tem arquivos para publicar.',
  libraryCuratorRequired:
    'É necessário acesso de gerente de conteúdo da biblioteca para publicar.',
} satisfies DriveManagementCopy;
